import config from "@/config";

export const HP_CLIENT_THEME = "hp-client";
/** Admin PrintHouses.TenantId for HP Auto Quote. Set HP_TENANT_ID in env / config.ts. */
export const HP_TENANT_ID = String(config.hp_tenant_id || "").toLowerCase();

/** HP when Theme is hp-client, or TenantId matches HP_TENANT_ID. */
export const isHpClientTheme = (
  theme?: string | null,
  tenantId?: string | null,
): boolean => {
  if (theme?.trim().toLowerCase() === HP_CLIENT_THEME) {
    return true;
  }
  if (!HP_TENANT_ID) {
    return false;
  }
  return tenantId?.trim().toLowerCase() === HP_TENANT_ID;
};
